export default __webpack_public_path__ + "static/media/scikit-learn.4888cd6d.svg";